const getlabelFeildMapping = item => {
  let label = "";
  if (item.displayText) {
    label = `${item.displayText}`;
  } else if (item.code) {
    label = `${item.code} - ${item.name}`;
  }
  return label;
};

export const getSalesPartnerMapping = (tempList: any[]) => {
  const list = Array.isArray(tempList)
    ? tempList.map(e => ({
        label: getlabelFeildMapping(e),
        value: `${e.code}`
      }))
    : [];
  return list;
};
